module.exports = __webpack_public_path__ + "img/logo-blue.79d871d9.png";